export const styles = {
  dialog: {
    paper: {
      borderRadius: 2,
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
      maxWidth: '430px',
    },
  },
  dialogTitle: {
    pb: 1,
    display: 'flex',
    padding: '8px 32px',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
    height: '64px',
    borderBottom: '1px solid rgba(19, 20, 20, 0.12)',
  },
  titleTypography: {
    fontWeight: '600',
  },
  closeButton: {
    color: 'rgba(0, 0, 0, 0.54)',
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '24px 32px !important',
    '& .MuiTextField-root': {
      backgroundColor: '#ffffff',
      padding: '0',
    },
  },
  sectionTitle: {
    fontWeight: '600',
  },
  dialogActions: {
    px: 3,
    pb: 2,
    display: 'flex',
    padding: '24px 32px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '20px',
    alignSelf: 'stretch',
    height: '90px',
    borderTop: '1px solid rgba(19, 20, 20, 0.12)',
  },
  button: {
    fontWeight: 600,
    padding: '8px 16px',
    minWidth: '90px',
    margin: '0',
  },
} as const;
